module.exports = __webpack_public_path__ + "static/img/3h.975434b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3h.jpg
// module id = 8XeH
// module chunks = 0